module.exports = __webpack_public_path__ + "static/images/full-star.22lv0jo.svg";